var map = {
	"./bancomontepio-logo-white.png": 37023,
	"./gorate-logo-white.svg": 70579,
	"./gorate-logo.svg": 94867,
	"./icon-only.png": 97081,
	"./montepio-logo.webp": 54469,
	"./ool-logo-white.png": 4893,
	"./ool-logo.png": 31201
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95379;